// src/Store/Slices/Student/Application/applicationSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchStudentApplicationsThunk,updateStudentApplicationThunk,StudentApplicationThunk } from "./application.action"; // Import the second thunk

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
  applications: [],
  total: 0,
  currentPage: 1,
  cache: null, 
};

const studentApplicationSlice = createSlice({
  name: "studentApplication",
  initialState,
  reducers: {
    setCache: (state, action) => {
      state.cache = action.payload;
    },
    resetApplicationState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    // Create application
    builder
      .addCase(StudentApplicationThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(StudentApplicationThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload?.data || null;
      })
      .addCase(StudentApplicationThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to submit application.";
        state.success = false;
      });

    // Fetch all applications
    builder
      .addCase(fetchStudentApplicationsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentApplicationsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.applications = action.payload?.data || [];
        state.total = action.payload?.total || 0;
        state.currentPage = action.payload?.currentPage || 1;
      })
      .addCase(fetchStudentApplicationsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch applications.";
      });

    // Update application
builder
  .addCase(updateStudentApplicationThunk.pending, (state) => {
    state.loading = true;
    state.error = null;
    state.success = false;
  })
  .addCase(updateStudentApplicationThunk.fulfilled, (state, action) => {
    state.loading = false;
    state.success = true;
    state.data = action.payload?.data || null;

    // Optionally update applications list if needed
    const updated = action.payload?.data;
    const index = state.applications.findIndex(app => app._id === updated?._id);
    if (index !== -1 && updated) {
      state.applications[index] = updated;
    }
  })
  .addCase(updateStudentApplicationThunk.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload || "Failed to update application.";
    state.success = false;
  });
  },
});

export const { setCache, resetApplicationState } = studentApplicationSlice.actions;
export default studentApplicationSlice.reducer;
